import type { IAnalyticsProvider } from '../models'
import { YandexMetrikaProvider } from '../providers/YandexMetrikaProvider'
import { AnalyticsService } from '../services'
import { useAnalyticsStore } from '../store'
import { AnalyticsSupport } from '../support/AnalyticsSupport'

export const useAnalytics = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(AnalyticsService)
    },
    get support() {
      return alt.get(AnalyticsSupport)
    },
    get store() {
      return useAnalyticsStore()
    },
    /** Активный провайдер веб-аналитики (MVP — Яндекс Метрика) */
    get provider(): IAnalyticsProvider {
      return alt.get(YandexMetrikaProvider)
    },
  }
}
